import React from 'react';
import { useDispatch } from 'react-redux';

import { setIsConfirmationModalOpen } from '@app/redux/updateBillCycle';

import { ManageBilling } from '../';

// Implemented as a separate route (/PayBill/UpdateBillCycle) to support opening this page directly from an email
// Route then switches to /PayBill/SelectBillCycle when clicking "Continue" in this entry-point confirmation modal
const UpdateBillCycle = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    // Entry-point modal: "Before you change your bill date, please remember"
    dispatch(setIsConfirmationModalOpen(true));
  }, [dispatch]);

  return <ManageBilling />;
};

export default UpdateBillCycle;
